(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('platform195Pill', platform195Pill);

    function platform195Pill() {
        return {
            restrict: 'A',
            scope: '@',
            estabId: '@',
            link($scope, $el, $attrs) {
                const el = $el[0];
                const parent = el && el.closest('.pills-container');
                const internalPill = parent && parent.querySelector('.sc-c-pill__label--not-sponsored');
                const estabId = $attrs.estabId;

                const getDataFromJSON = obj => {
                    return JSON.parse(obj);
                };

                // Move into the estab page
                const getSponsoredEstab = ({ estabId }) => {
                    const json = localStorage.getItem(`platform195Estab${estabId}`);
                    const serialized = json !== null ? json : '';
                    let { hotelId = '' } = getDataFromJSON(serialized);
                    hotelId = parseInt(hotelId);
                    estabId = parseInt(estabId);

                    if (estabId !== hotelId) {
                        return false;
                    }
                    return true;
                };

                const platform195settings = { estabId };
                const platform195Estab = localStorage.getItem(`platform195Estab${estabId}`) && getSponsoredEstab(platform195settings);

                if (!platform195Estab) {
                    el && el.classList.add('hidden');
                }
                if (platform195Estab) {
                    internalPill && internalPill.closest('.pills_hotel--facilities').classList.add('hidden');
                }
            }
        };
    }
})();
